export const VENUE_ATTRIBUTES: { key: string; label: string; group: string }[] = [
  // Diet
  { key: "diet:vegetarian", label: "Vegetarian", group: "Diet" },
  { key: "diet:vegan", label: "Vegan", group: "Diet" },
  { key: "diet:halal", label: "Halal", group: "Diet" },
  { key: "diet:jain", label: "Jain", group: "Diet" },
  // Group-friendly
  { key: "family_friendly", label: "Family-friendly", group: "Group-friendly" },
  { key: "good_for_groups", label: "Good for groups", group: "Group-friendly" },
  { key: "dine_in", label: "Dine-in", group: "Group-friendly" },
  { key: "serves_alcohol", label: "Serves alcohol", group: "Group-friendly" },
  { key: "live_music", label: "Live music", group: "Group-friendly" },
  // Access
  { key: "wheelchair", label: "Wheelchair accessible", group: "Access" },
  { key: "dog", label: "Dog-friendly", group: "Access" },
  { key: "restroom", label: "Restrooms", group: "Access" },
  { key: "near_transit", label: "Near public transport", group: "Access" },
  // Amenities
  { key: "outdoor_seating", label: "Outdoor seating", group: "Amenities" },
  { key: "parking", label: "Parking", group: "Amenities" },
  { key: "free_parking", label: "Free parking", group: "Amenities" },
  { key: "delivery", label: "Delivery", group: "Amenities" },
  { key: "takeout", label: "Takeout", group: "Amenities" },
];

/** Return the attribute keys that have a truthy, non-"no" value. */
export function activeAttrs(attrs: Record<string, string>): string[] {
  return Object.entries(attrs)
    .filter(([, v]) => v && v !== "no")
    .map(([k]) => k);
}
